import { Box } from '@mantine/core';
import { keyframes } from '../utils/keyframes';
import { forwardRef } from 'react';
import { useReducedMotion } from '../hooks';

export interface WiggleProps {
  children: React.ReactNode;
  active?: boolean;
  duration?: number;
  angle?: number;
  infinite?: boolean;
  count?: number;
}

const Wiggle = forwardRef<HTMLDivElement, WiggleProps>(
  (
    {
      children,
      active = true,
      duration = 500,
      angle = 10,
      infinite = false,
      count = 1,
    },
    ref
  ) => {
    const reducedMotion = useReducedMotion();

    if (reducedMotion || !active) {
      return <Box ref={ref}>{children}</Box>;
    }

    const iterationCount = infinite ? 'infinite' : count;

    const wiggleKeyframes = keyframes({
      '0%, 100%': { transform: 'rotate(0deg)' },
      '25%': { transform: `rotate(${angle}deg)` },
      '50%': { transform: 'rotate(0deg)' },
      '75%': { transform: `rotate(-${angle}deg)` },
    });

    return (
      <Box
        ref={ref}
        style={{
          animation: `${wiggleKeyframes} ${duration}ms ease-in-out ${iterationCount}`,
          transformOrigin: 'center bottom',
        }}
      >
        {children}
      </Box>
    );
  }
);

Wiggle.displayName = 'Wiggle';

export default Wiggle;
